






















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbAlert, mdbRow, mdbCol, mdbInput, mdbSelect, mdbBtn, mdbIcon } from '@folky-tools/mdbvue';
import { globalizationService } from '@/services';
import { Address } from '@/models/common/address';
import { Country } from '@/models/globalization/country';
import { State } from '@/models/globalization/state';
import { gmaps } from '@/plugins/gmaps';

@Component({
    components: {
        mdbAlert,
        mdbInput,
        mdbSelect,
        mdbRow,
        mdbCol,
        mdbBtn,
        mdbIcon
    }
})
export default class EditAddress extends Vue {
    @Prop(Address) private address!: Address;
    @Prop({ type: Boolean, default: true }) private showLinkToGoogleMaps!: boolean;
    private countries: Country[] = [];
    private states: State[] = [];

    private async mounted(): Promise<void> {
        const countries = await globalizationService.getCountries();

        if (this.address.countryId! > 0) {
            countries.find(c => c.id === this.address.countryId)!.selected = true;
        } else if (countries.length === 1) {
            countries[0].selected = true;
        }
        this.countries = countries;
    }

    private async onChangeCountry(value: number, text: string): Promise<void> {
        if (value) {
            const country = this.countries.find(c => c.id! === value);

            this.address.countryId = country!.id;
            this.address.countryName = country!.name;

            const states = await globalizationService.getStates(value);

            if (this.address.stateId! > 0 && states.some(s => s.id === this.address.stateId!)) {
                states.find(s => s.id === this.address.stateId)!.selected = true;
            }
            this.states = states;
        } else {
            this.address.countryId = undefined;
            this.address.countryName = undefined;
            this.address.stateId = undefined;
            this.address.stateName = undefined;

            this.states = [];
        }
    }

    private onChangeState(value: number, text: string): void {
        if (value) {
            const state = this.states.find(s => s.id! === value);

            this.address.stateId = state!.id;
            this.address.stateName = state!.name;
        } else {
            this.address.stateId = undefined;
            this.address.stateName = undefined;
        }

        this.$emit('address-state-changed', this.address.stateId);
    }

    get linkToGoogleMaps() {
        const addressToQuery = gmaps.getUrlOfAddress(this.address);

        if (addressToQuery) {
            return addressToQuery;
        }

        return null;
    }
}
